import { DefaultButton, PrimaryButton, ProgressIndicator, TextField } from "@fluentui/react";
import {
    defaultButtonStyles, primaryButtonStyles, styles, textFieldStyles
} from "../../common/views/DefaultStyles";
import { RouteUtils } from "../../common/views/RouteUtils";
import { Utils } from "../../common/views/Utils";
import { ChangePasswordModel } from "../models/AccountTypes";

type ChangePasswordProps = {
    form: ChangePasswordModel;
    errorMessages: any;
    loading: boolean;
    onValueChange: (field: keyof ChangePasswordModel, value: any) => void;
    submit: () => void;
}

export function ChangePasswordView({
    form, errorMessages, loading, onValueChange, submit
}: ChangePasswordProps) {
    const isMobile = Utils.isMobile();
    const id = "login-form-wrapper" + (isMobile ? "-mobile" : "");
    const width6 = Utils.getColumnWidth(6);
    const width12 = Utils.getColumnWidth(12);

    const currentPasswordInput = () => {
        return <div className="ms-Grid-row left">
            <div className={width12}>
                <TextField
                    label="Current Password"
                    defaultValue={form.currentPassword}
                    required
                    errorMessage={errorMessages.currentPassword}
                    onChange={(_, v) => onValueChange("currentPassword", v || "")}
                    styles={textFieldStyles}
                    type="Password"
                />
            </div>
        </div>;
    }

    const newPasswordInput = () => {
        return <div className="ms-Grid-row left">
            <div className={width12}>
                <TextField
                    label="New Password"
                    defaultValue={form.newPassword}
                    required
                    errorMessage={errorMessages.newPassword}
                    onChange={(_, v) => onValueChange("newPassword", v || "")}
                    styles={textFieldStyles}
                    type="Password"
                />
            </div>
        </div>;
    }

    const buttons = () => {
        return <div className="ms-Grid-row pt-20">
            <div className={width6}>
                <DefaultButton onClick={RouteUtils.goHome} styles={defaultButtonStyles}>
                    Cancel
                </DefaultButton>
            </div>
            <div className={width6}>
                <PrimaryButton onClick={submit} styles={primaryButtonStyles}>
                    Submit
                </PrimaryButton>
            </div>
        </div>;
    }

    return <div id={id} className="pv-10 ph-15" style={styles.middle}>
        <div className="login-form box">
            <div className="ms-Grid left ph-0">
                <div className={"left font-title p-15"} style={{ paddingTop: 6 }}>
                    Change Password
                </div>

                <hr style={{ backgroundColor: "lightgray", height: 1, border: "none" }} />

                <div className="pt-10 pb-20 ph-15">
                    {currentPasswordInput()}
                    {newPasswordInput()}
                    {!loading && buttons()}
                    {loading && <div className="pt-20">
                        <ProgressIndicator label="Submitting" description="" />
                    </div>}
                </div>
            </div>
        </div>
    </div>;
}